import React from 'react';
import PropTypes from 'prop-types';

export default function BookerSendEmail({
  softwares,
  business,
  onBookerEmailSent,
  onBack,
}) {
  const { bookerAccountInfo } = softwares;
  const { clientUser } = business;
  const emailContent = {
    subject: 'Request Authorization for TrueLark',
    body: `Hi Booker API Team! \n\nI would like to grant API access to TrueLark for my Booker Account.\n\nHere are details for my account: \n* Account Name: ${bookerAccountInfo.businessAccount}\n* Location ID: ${bookerAccountInfo.locationID}\n* Primary Contact Name: ${bookerAccountInfo.name}\n* Primary Contact Email Address: ${bookerAccountInfo.email}\n* Address: ${bookerAccountInfo.address}\n Thank You.`,
    to: 'api@mindbodyonline.com',
    cc: 'support@truelark.com',
  };

  const ticketformURL = `https://support.mindbodyonline.com/s/contactapisupport?language=en_US`;

  return (
    <div className="booker-send-email">
      <h4>Request Access</h4>
      <p>
        Please fill the ticketing form with data shown below. Click on the
        button <span>Fill the form</span> to open the form in a new tab.
      </p>
      <div className="booker-send-email__email">
        <div className="booker-send-email__email__body">
          <form className="booker-ticket-form">
            <div>
              <label for="name">Name</label>
              <input name="name" value={bookerAccountInfo.name} readOnly />
            </div>
            <div>
              <label for="name">Email</label>
              <input name="name" value={bookerAccountInfo.email} readOnly />
            </div>
            <div>
              <label for="name">Phone</label>
              <input name="name" value={clientUser.phone} readOnly />
            </div>
            <div>
              <label for="name">Product</label>
              <select>
                <option value="Booker" selected>
                  Booker
                </option>
              </select>
            </div>
            <div>
              <label for="name">Location ID/Site ID</label>
              <input
                name="name"
                value={bookerAccountInfo.locationID}
                readOnly
              />
            </div>
            <div>
              <label for="name">I need help with</label>
              <select>
                <option value="API" selected>
                  API
                </option>
              </select>
            </div>
            <div>
              <label for="name">Severity</label>
              <select>
                <option value="High" selected>
                  High
                </option>
              </select>
            </div>
            <div>
              <label for="name">Subject</label>
              <input name="name" value={emailContent.subject} readOnly />
            </div>
            <div>
              <label for="name">Description</label>
              <textarea name="name" value={emailContent.body} readOnly />
            </div>
          </form>
        </div>
      </div>
      <div className="booker-send-email__actions">
        <button
          className="btn btn--secondary btn--lg"
          type="button"
          onClick={onBack}
        >
          Previous
        </button>
        <a
          href={ticketformURL}
          className="fill-form btn btn--secondary btn--lg"
          target="_blanck"
        >
          Fill the form
        </a>
        <button
          className="btn btn--primary btn--lg"
          onClick={onBookerEmailSent}
        >
          Next
        </button>
      </div>
    </div>
  );
}

BookerSendEmail.propTypes = {
  onBack: PropTypes.func.isRequired,
  onBookerEmailSent: PropTypes.func.isRequired,
  softwares: PropTypes.shape().isRequired,
};
